import { BUSINESS, businessAddress, businessRegistrationLine } from "@/lib/business";

/**
 * Public seller identity block. Buyers (and card networks) expect to see who
 * they are paying before they pay. Fields that are not configured yet are
 * omitted rather than rendered as placeholders.
 */
export const SellerIdentity = ({ className = "" }: { className?: string }) => {
  const address = businessAddress();
  const registration = businessRegistrationLine();

  return (
    <address className={`not-italic text-xs text-muted-foreground leading-relaxed ${className}`}>
      <span className="text-foreground font-medium">{BUSINESS.legalName}</span>
      {" — seller of record for "}
      {BUSINESS.tradingName}
      {address && <> · {address}</>}
      {registration && <> · {registration}</>}
      <br />
      <a href={`mailto:${BUSINESS.email}`} className="hover:text-foreground transition-colors">
        {BUSINESS.email}
      </a>
      {BUSINESS.phone && <> · {BUSINESS.phone}</>}
      {" · Card payments are processed securely by Stripe. We never see or store your card details."}
    </address>
  );
};

export default SellerIdentity;
